import { useState } from "react";
import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function HotTopics() {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? topics : topics.slice(0, 6);

  return (
    <section id="hot-topics" className="px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs px-3 py-1 rounded-full bg-accent-100 text-accent-900 mb-3">
            <i className="ri-fire-line"></i>
            正在被讨论
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">热门话题推荐</h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">社区里讨论度最高的一批话题,点进去就能看到大家的观点。</p>
        </div>
        <Link to="/topics" className="text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap">
          浏览话题广场
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {visible.map((t) => (
          <TopicCard key={t.id} topic={t} />
        ))}
      </div>

      {!showAll && (
        <div className="flex justify-center mt-10">
          <button
            type="button"
            onClick={() => setShowAll(true)}
            className="px-6 py-3 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer flex items-center gap-2"
          >
            <i className="ri-add-line"></i>
            展开更多话题
          </button>
        </div>
      )}
    </section>
  );
}